// extracted by mini-css-extract-plugin
export default {"navEdit":"navEdit_navEdit__no-kD","navWithProgress":"navEdit_navWithProgress__qsCid","leftBtn":"navEdit_leftBtn__q-UWR","rightBtn":"navEdit_rightBtn__vK8fD"};